<template>
  <side-bar v-show="isSidebarActiveLocal" position-right class="z-10 max-w25">
    <div class="flex  sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white uppercase ">
        Add Sub-Category
      </h2>

      <feather-icon
        icon="XIcon"
        @click="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <div class="p-4">
      <div class="mb-4">
        <FileUploader />
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">IsParentr</p>
        <base-input>
          <select class="form-control">
            <option disabled="true">Select</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </base-input>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Select Category</p>
        <base-input>
          <select class="form-control">
            <option> Select </option>
            <option> MensBottom </option>

            <option> WomensBottom </option>
            <option> Ethnic Wear </option>
            <option> Indo-western </option>
          </select>
        </base-input>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Category</p>
        <b-input placeholder="Enter  Category..." />
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Sub Category</p>
        <b-input placeholder="Enter Sub Category..." />
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">IsFeature</p>
        <base-input>
          <select class="form-control">
            <option disabled="true">Select</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </base-input>
      </div>
    </div>
    <footer class="footer-fix fixed bottom-0	w-1/4 ">
      <base-button block type="primary" class="rounded-none font-semibold"
        >SUBMIT</base-button
      >
    </footer>
  </side-bar>
</template>
<script>
import FileUploader from "@/components/FileUploader.vue";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {};
  },
  components: {
    FileUploader
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    }
  }
};
</script>
